import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateProgramSubAffiliateListItem } from '../types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_API_URL,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS,
} from '../constants';

export default function useAffiliateProgramSubAffiliateDealsListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramSubAffiliateListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramSubAffiliateListItem>>({
    queryKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramSubAffiliateListItem>>(
      AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
